import OriginalCheckboxGroup from './CheckboxGroup.svelte';
import GroupLabel from './GroupLabel.svelte';
import OriginalCheckbox from './Checkbox.svelte';
import Label from './Label.svelte';
import Description from './Description.svelte';
const CheckboxGroup = OriginalCheckboxGroup;
CheckboxGroup.Label = GroupLabel;
CheckboxGroup.Checkbox = OriginalCheckbox;
CheckboxGroup.Checkbox.Label = Label;
CheckboxGroup.Checkbox.Description = Description;
export default CheckboxGroup;
